export default "__VITE_ASSET__BoF0wUMJ__"